import actionHelper from 'common/utils/action-helper';

export const USER = {
  LOGIN: actionHelper('USER_LOGIN'),
  LOGOUT: actionHelper('USER_LOGOUT'),
  FETCH: actionHelper('USER_FETCH'),
};

